enum OrganizationFeature {
  DISALLOW_COLOR = "disallowColor",
}

export default OrganizationFeature;
